import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, SearchX } from 'lucide-react';

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50 flex items-center justify-center px-4">
            <div className="max-w-lg w-full text-center">
                {/* Illustration */}
                <div className="relative mb-8">
                    <div className="text-[150px] font-black text-orange-100 leading-none select-none">
                        404
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-24 h-24 bg-orange-500 rounded-full flex items-center justify-center shadow-lg shadow-orange-200">
                            <SearchX className="w-12 h-12 text-white" />
                        </div>
                    </div>
                </div>

                {/* Texte */}
                <h1 className="text-3xl font-bold text-gray-800 mb-3">
                    Page introuvable
                </h1>
                <p className="text-gray-500 mb-8 max-w-sm mx-auto">
                    Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
                </p>

                {/* Actions */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center px-5 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all shadow-sm"
                    >
                        <ArrowLeft className="w-4 h-4 mr-2" />
                        Retour
                    </button>
                    <button
                        onClick={() => navigate('/')}
                        className="flex items-center px-5 py-2.5 text-sm font-medium text-white bg-orange-500 rounded-lg hover:bg-orange-600 transition-all shadow-sm shadow-orange-200"
                    >
                        <Home className="w-4 h-4 mr-2" />
                        Accueil
                    </button>
                </div>

                {/* Footer */}
                <p className="mt-12 text-xs text-gray-400">
                    ANPE &mdash; Base de données de compétences
                </p>
            </div>
        </div>
    );
};

export default NotFoundPage;
